import Repository from "./Repository";

const formDataConfig = {
    headers: { "Content-Type" : "multipart/form-data" }
};

const addMultiple = "/marcom/audience/addMultipleAudience";
// const GetImage = "/BrainstormUserSettingsApi/GetImages";

export default {
    addMultipleAudience(payload) {
    return Repository.post(`${addMultiple}`, payload);
  },
};